import axios, { endpoints } from 'src/utils/axios';

export const createCompany = async (params) => {
  try {
    const formData = new FormData();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined) formData.append(key, value);
    });
    const res = await axios.post(endpoints.auth.createCompany, formData);
    return res.data;
  } catch (error) {
    console.error('Error during create company:', error);
    throw error;
  }
};

export const updateCompanyDetails = async (params) => {
  try {
    const formData = new FormData();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined) formData.append(key, value);
    });
    const res = await axios.post(endpoints.auth.updateCompanyDetails, formData);
    return res.data;
  } catch (error) {
    console.error('Error during update company details:', error);
    throw error;
  }
};
